var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useRef, useState, useEffect, } from 'react';
import classNames from 'classnames';
import { mergeRefs } from '../mergeRefs';
import { CardAction } from './CardAction';
import { fixedForwardRef } from '../fixedForwardRef';
function WithCardActionForwardRef(props, ref) {
    var children = props.children, _a = props.as, Comp = _a === void 0 ? 'div' : _a, onClick = props.onClick, className = props.className, baseClassName = props.baseClassName, rest = __rest(props, ["children", "as", "onClick", "className", "baseClassName"]);
    var cardActionInnerRef = useRef(null);
    var _b = useState(), isUsingCardAction = _b[0], setIsUsingCardAction = _b[1];
    /** Før att hover og focus skall fungera i browsers som ikke støtter :has.
     * Allt med klassen '--clickable' kan eftervart fjernes. */
    useEffect(function () {
        var isStillUsingCardAction = !!cardActionInnerRef.current;
        if (isUsingCardAction !== isStillUsingCardAction) {
            setIsUsingCardAction(isStillUsingCardAction);
        }
    }, [isUsingCardAction]);
    var PartialAppliedCardAction = useCallback(function (_a, cardActionRef) {
        var cardActionClassName = _a.className, restCardAction = __rest(_a, ["className"]);
        return (React.createElement(CardAction, __assign({ className: classNames(cardActionClassName, 'ffe-card__action', {
                'ffe-card__action--raw': !cardActionClassName,
            }), ref: cardActionRef
                ? mergeRefs([cardActionRef, cardActionInnerRef])
                : cardActionInnerRef }, restCardAction)));
    }, []);
    return (React.createElement(Comp, __assign({}, rest, { className: classNames(className, isUsingCardAction && "".concat(baseClassName, "--clickable")), onClick: function (e) {
            var _a, _b, _c;
            var hasSelectedText = !!((_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.toString().length);
            if (!hasSelectedText &&
                !((_b = cardActionInnerRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target))) {
                (_c = cardActionInnerRef.current) === null || _c === void 0 ? void 0 : _c.click();
            }
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }, ref: ref }), children({
        CardAction: fixedForwardRef(PartialAppliedCardAction),
    })));
}
export var WithCardAction = fixedForwardRef(WithCardActionForwardRef);
